module.exports = __webpack_public_path__ + "img/Bobo.cc77d9dc.png";